import React, { useState } from "react";
import "./HandoffModal.css";

const HandoffModal = ({
  onClose,
  onComplete,
}) => {

  const [device, setDevice] =
    useState("Haiku");

  const [transferred, setTransferred] =
    useState(false);


  const handleTransfer = () => {

    setTransferred(true);

    if (onComplete) {
      onComplete();
    }

  };


  return (

    <div className="modal-overlay">

      <div className="handoff-modal">

        <div className="modal-header">

          <h2>
            Handoff to Mobile
          </h2>

          <button
            className="close-btn"
            onClick={onClose}
          >
            ×
          </button>

        </div>


        {!transferred ? (

          <>

            <p className="handoff-description">

              Continue this virtual visit
              from a mobile device.

            </p>


            <div className="device-selection">

              <label>

                <input
                  type="radio"
                  checked={device === "Haiku"}
                  onChange={() =>
                    setDevice("Haiku")
                  }
                />

                Mobile Clinician (Phone)

              </label>


              <label>

                <input
                  type="radio"
                  checked={device === "Canto"}
                  onChange={() =>
                    setDevice("Canto")
                  }
                />

                Mobile Clinician (Tablet)

              </label>

            </div>


            <div className="mobile-device-card">

              <div>

                <strong>
                  Connected Device
                </strong>

                <p>
                  Halpert's Tablet
                </p>

              </div>

              <div>

                <strong>
                  Status
                </strong>

                <p className="connected">

                  ● Connected

                </p>

              </div>

            </div>


            <button
              className="transfer-btn"
              onClick={handleTransfer}
            >

              Transfer Visit

            </button>

          </>

        ) : (

          <>

            <div className="transfer-success">

              ✓ Visit Successfully Handed Off

            </div>


            <div className="transfer-summary">

              <p>

                <strong>Device</strong>

                <br />

                {device}

              </p>


              <p>

                <strong>Status</strong>

                <br />

                Connected

              </p>


              <p>

                <strong>Desktop Session</strong>

                <br />

                Active for 30 seconds

              </p>

            </div>


            <div className="info-box">

              The desktop session will remain
              active while the mobile device
              joins the meeting.

            </div>


            <button
              className="done-btn"
              onClick={onClose}
            >

              Done

            </button>

          </>

        )}

      </div>

    </div>

  );

};

export default HandoffModal;